import React from 'react'
import { useFetch } from '../../hooks/useFetch'
import { goustoAPI } from '../../config/routes'

const withOrders = (Component) => (props) => {
  const { forceRender } = props

  const { isFetchLoading, fetchError, fetchResponse } = useFetch({
    url: goustoAPI.orders,
    parameters: {
      limit: 10,
      sort_order: 'desc',
      state: 'pending',
    },
    needsAuthorization: true,
  })

  if (!forceRender && (isFetchLoading || fetchError || !fetchResponse?.result?.data?.length)) {
    return null
  }

  return (
    <Component
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      isFetchingOrders={isFetchLoading}
      orders={fetchResponse?.result?.data || null}
    />
  )
}

export { withOrders }
